import { defineStore } from 'pinia'
import { ref } from 'vue'
import { imagesApi } from '@/services/imagesApi'

export const useImagesStore = defineStore('images', () => {
  const enabled = ref(false)
  const provider = ref<string>('')
  const lastFetched = ref<number | null>(null)

  const TTL = 5 * 60 * 1000 // 5 minutes

  const fetchStatus = async (force = false) => {
    const now = Date.now()
    if (!force && lastFetched.value && (now - lastFetched.value) < TTL) return
    try {
      const res = await imagesApi.status()
      enabled.value = !!res.data?.enabled
      provider.value = res.data?.provider || ''
      lastFetched.value = now
    } catch {
      enabled.value = false
      provider.value = ''
    }
  }

  const invalidate = () => { lastFetched.value = null }

  return { enabled, provider, fetchStatus, invalidate }
})

